import { createSlice } from '@reduxjs/toolkit'
import { AxiosError } from '@src/helpers/httpClient'

import { ASSESSMENT_FORMATIVE_CREATE, ASSESSMENT_FORMATIVE_LIST, GLOBAL_STATE } from '../constants/actionTypes'
import * as actionCreators from './actions'
import { initialState } from './initialState'

export const ASSESSMENT_FORMATIVE = GLOBAL_STATE

const assessmentFormativeSlice = createSlice({
  name: ASSESSMENT_FORMATIVE,
  initialState,
  reducers: {},
  extraReducers(builder) {
    builder
      .addCase(actionCreators.assessmentFormativeCreate.pending, state => {
        state[ASSESSMENT_FORMATIVE_CREATE].loading = true
      })
      .addCase(actionCreators.assessmentFormativeCreate.rejected, (state, action) => {
        state[ASSESSMENT_FORMATIVE_CREATE].loading = false
        state[ASSESSMENT_FORMATIVE_CREATE].error = action.payload as AxiosError
      })
      .addCase(actionCreators.assessmentFormativeCreate.fulfilled, (state, action) => {
        state[ASSESSMENT_FORMATIVE_CREATE].loading = false
        state[ASSESSMENT_FORMATIVE_CREATE].error = null
        state[ASSESSMENT_FORMATIVE_CREATE].data = action.payload
      })

    builder
      .addCase(actionCreators.assessmentFormativeList.pending, state => {
        state[ASSESSMENT_FORMATIVE_LIST].loading = true
      })
      .addCase(actionCreators.assessmentFormativeList.rejected, (state, action) => {
        state[ASSESSMENT_FORMATIVE_LIST].loading = false
        state[ASSESSMENT_FORMATIVE_LIST].error = action.payload as AxiosError
      })
      .addCase(actionCreators.assessmentFormativeList.fulfilled, (state, action) => {
        state[ASSESSMENT_FORMATIVE_LIST].loading = false
        state[ASSESSMENT_FORMATIVE_LIST].error = null
        state[ASSESSMENT_FORMATIVE_LIST].data = action.payload
      })

    builder.addCase(actionCreators.assessmentFormativeListClear, state => {
      state[ASSESSMENT_FORMATIVE_LIST] = initialState().ASSESSMENT_FORMATIVE_LIST
    })
  },
})

export const { reducer: assessmentFormativeReducer } = assessmentFormativeSlice
